import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';

const container = document.getElementById('root');
const app = (
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// We intentionally do NOT hydrate. react-snap prerenders HTML for SEO and fast first
// paint, but it targets React 16's lenient ReactDOM.hydrate; React 18's strict
// hydrateRoot rejects react-snap's snapshots over subtle markup/whitespace/text-node
// differences (errors #418/#423) and then discards and re-renders the entire root
// anyway — a remount that can wipe a user's in-progress state mid-session (e.g. images
// queued on the Images-to-PDF tool). createRoot client-renders over the prerendered
// markup (identical output) with no hydration step, so there are no mismatch errors and
// no surprise remount. Crawlers and the initial paint still get the prerendered HTML.
createRoot(container).render(app);

// Signal react-snap to snapshot after lazy-loaded components have mounted.
setTimeout(() => document.dispatchEvent(new Event('app-ready')), 300);
